/**
 * @author gabyong.kim
 * @email gabyong.kim@gloovir.com
 * @create date 2023-11-12 11:35:34
 * @modify date 2023-11-12 11:35:34
 * @desc [description]
 */

import ContentsProps from "interfaceTypes/ContentsProps";
import { Fragment, useState } from "react";
import { Route, Routes } from "react-router-dom";
import { PAGE_URL } from "value/Url";
import StorageMgmtContainer from "./StorageMgmtContainer";
import StorageDetailContainer from "./StorageDetailContainer";
import VmNetworkDetailContainter from "components/virtLogicalResource/network/VmNetworkDetailContainer";


export default function StoragePage(props:ContentsProps) {
  const [detailId, setDetailId] = useState('');

    function moveDetail(targetId) {
        setDetailId(targetId);
    }

    return (
        <Fragment>
            <Routes>
                <Route path={`/`} element={<StorageMgmtContainer setLoading={props.setLoading} showSlideModalCb={props.showSlideModalCb} showPopupModalCb={props.showPopupModalCb} moveDetailCb={moveDetail}/>} />
                <Route path={`/${PAGE_URL.DETAIL_MANAGEMENT}`} element={<StorageDetailContainer setLoading={props.setLoading} showSlideModalCb={props.showSlideModalCb} showPopupModalCb={props.showPopupModalCb} targetId={detailId}/>} />
            </Routes>
        </Fragment>
    )
}